import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import { Card } from "react-bootstrap";
import Sidebar from "./SideBar";

const CourseSideBar = ({
  getActiveContent,
  courseDetails,
  activeContent,
  isSubmittingQuiz,
  getCompletedSection,
  isQuizInProgress,
}) => {
  // Debugging: Log the structure of courseDetails and its sections
  useEffect(() => {
    console.log("Course Details:", courseDetails);
    console.log("Sections in Course Details:", courseDetails?.sections);
  }, [courseDetails]);
 useEffect(() => {
  console.log("CourseSideBar: isQuizInProgress value received is:", isQuizInProgress);
 }, [isQuizInProgress]);
  return (
    <section
      className="card course-sidebar mx-3 mt-2"
      id="courseAccordion"
      style={{ maxHeight: "80vh", overflow: "hidden" }}
    >
      <SimpleBar
        style={{ maxHeight: "100%", overflowY: "auto" }}
        className="py-0 my-0"
      >
        <Card>
          <Card.Header className="px-3">
            <h4 className="mb-0">{courseDetails?.courseTitle}</h4>
          </Card.Header>
          <Sidebar
            getActiveContent={getActiveContent}
            accordionItems={
              courseDetails?.sections?.sort(
                (a, b) => a.sectionNumber - b.sectionNumber
              ) || []
            } // Passes sections to Sidebar
            isCourseCompleted={courseDetails?.courseCompleted}
            activeContent={activeContent?.contentId}
            isSubmittingQuiz={isSubmittingQuiz}
            setCompletedSection={getCompletedSection}
            isQuizInProgress={isQuizInProgress}
          />
        </Card>
      </SimpleBar>
    </section>
  );
};

CourseSideBar.propTypes = {
  getActiveContent: PropTypes.func.isRequired,
  courseDetails: PropTypes.object.isRequired,
  activeContent: PropTypes.object.isRequired,
  isSubmittingQuiz: PropTypes.bool.isRequired,
  getCompletedSection: PropTypes.func.isRequired,
  isQuizInProgress: PropTypes.bool.isRequired,
};

export default CourseSideBar;
